// Lightweight GA4 helpers.
//
// These are intentional no-ops during prerendering: headless Chrome sets
// navigator.webdriver === true, so build-time snapshots never send analytics
// hits. They also no-op if gtag isn't available yet.
const isTrackable = () =>
  typeof window !== "undefined" &&
  !navigator.webdriver &&
  typeof window.gtag === "function";

export function trackPageView(path, title) {
  if (!isTrackable()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (!isTrackable()) return;
  window.gtag("event", name, params);
}
